import { ReloadOutlined } from '@ant-design/icons'
import { Button, Tooltip } from 'antd'

import { useAreaTreeStore } from '../Store/hooks'

export const ReloadAreaTreeButton = () => {
  const reload = useAreaTreeStore(state => state.reload)
  return (
    <Tooltip title='刷新数据'>
      <Button icon={<ReloadOutlined />} type='text' onClick={reload} />
    </Tooltip>
  )
}
